module.exports = __webpack_public_path__ + "img/nav-thumbnail-nsmb-maps.5f43778c.png";